/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as global from "../../js/global";
import * as helper from "../../js/helper";
import full_loading from "../components/full-loading.vue";
import property_component_horizontal from "../components/property-component-horizontal.vue";
import search_filters_modal from "../modal/search-filters-modal.vue";
import filter_tablets_component from "../components/filter-tablets-component.vue";
const __vue_script__ = {
  components: {
    full_loading: full_loading,
    property_component_horizontal: property_component_horizontal,
    search_filters_modal: search_filters_modal,
    filter_tablets_component: filter_tablets_component,
  },
  name: "map_search_widget",
  props: {
    agency_name: {
        default: null,
    },
  },
  data() {
    return {
      is_ready:false,
      global,
      helper,
      frappe,
      search_filters: localStorage.map_search_filters
        ? JSON.parse(localStorage.map_search_filters)
        : global.search_filters,
      default_marker_width: 11,
      default_marker_height: 11,
      marker_width: 28,
      marker_height: 34,
      promote_ratio: 1,
      promote_opacity: 1,
      dim_opacity: 0.4,
      normal_opacity: 1,
      map: null,
      target_latlng: null,
      mashros: [],
      promoted_users: [],
      page: 0,
      refreshing_data: false,
      still_loading: false,
      property_name_list: [],
      property_list: [],
      clusters: [],
      group_by: 'property',
      hover_cluster:null,
      selected_property: null,
      hovered_mashro: null,
      hovered_property: null,
      hovered_property_type: null,
      prv_hovered_property_type: null,
      hovered_ad_type: null,
      prv_hovered_ad_type: null,
      prv_region: null,
      prv_city: null,
      prv_district: null,
      prv_zoom: null,
      big_lvl: 14,
      big_icon: false,
      property_type_count: {
        Apartment: 0,
      },
      ad_type_count: {
        Rent: 0,
        Sale: 0,
        Auction: 0,
      },
    };
  },
  async mounted() {
    this.checkFilterStructureUpdate();
    for (var _property_type of global.property_constants.property_keys) {
      this.property_type_count[_property_type] = 0
    }
    global.emitter.emit("show-full-loading");
    this.getCurrentPosition();
    global.emitter.on("load-search-again", (args) => {
      var is_any_change = false;
      if (!this.region_changed()) {
        // is_any_change = true;
      }
      if (!this.city_changed()) {
        // is_any_change = true;
      }
      if (!this.district_changed()) {
        // is_any_change = true;
      }
      if (is_any_change || true) {
        this.load_data();
      }
    });
  },
  methods: {
    checkFilterStructureUpdate: function (){
      const keys1 = Object.keys(global.search_filters);
      const keys2 = Object.keys(this.search_filters);
      if (keys1.length !== keys2.length){
        this.search_filters = global.search_filters;
      }else if(!keys1.every(key => keys2.includes(key))){
        this.search_filters = global.search_filters;
      }
      if(!this.agency_name){
        this.search_filters.agency = "";
      }
    },
    getCurrentPosition: function (){
      navigator.geolocation.getCurrentPosition(this.getCurrentPositionSuccess,this.getCurrentPositionError);
    },
    getCurrentPositionSuccess: function (position) {
      if(!this.is_ready){
        this.setup_things([position.coords.latitude, position.coords.longitude]);
      }else{
        this.search_filters.region = ""
        this.search_filters.city = ""
        global.emitter.emit("load_regions_n_cities");
        this.map.setView([position.coords.latitude, position.coords.longitude], 12);
      }
    },
    getCurrentPositionError: function () {
      if(!this.is_ready){
        this.setup_things();
      }
    },
    onLocationFound: function(e) {
      var radius = e.accuracy;

      L.marker(e.latlng).addTo(map)
          .bindPopup("You are within " + radius + " meters from this point").openPopup();

      L.circle(e.latlng, radius).addTo(map);
    },
    createMapButton: function (map) {
      var container = L.DomUtil.create('button',"map-button");
      container.type="button"
      container.innerHTML = '<i class="fa-solid fa-location-crosshairs"></i>';

      container.style.backgroundColor = 'white';
      container.style.width = '32px';
      container.style.height = '32px';
      
      container.onmouseover = function(){
        container.style.backgroundColor = '#f4f4f4'; 
      }
      container.onmouseout = function(){
        container.style.backgroundColor = 'white'; 
      }

      container.onclick = this.getCurrentPosition;

      return container;
    },
    setup_things: async function (initial_lat_lng = [24.69999996, 46.73333003]) {
      var initial_lat = initial_lat_lng[0];
      var initial_lng = initial_lat_lng[1];
      let corner1 = L.latLng(32.896210012370656, 33.96066018865814);
      let corner2 = L.latLng(15.613607036429755, 55.8301100044458);
      if(this.search_filters.location == null){
        this.search_filters.location = {
          center: [initial_lat, initial_lng],
          zoom: 11,
        }
      }

      var satellite_layer = L.tileLayer(
        "/api/method/maalek.api.geo_api.get_tile?type=satellite&z={z}&x={x}&y={y}",
        {
          attribution: '&copy; <a href="https://maalek.net">Maalek.Net</a>',
          
        }
      );
      var street_layer = L.tileLayer(
        "/api/method/maalek.api.geo_api.get_tile?type=light&z={z}&x={x}&y={y}",
        {
          attribution: '&copy; <a href="https://maalek.net">Maalek.Net</a>',
        }
      );
      this.map = L.map("map", {
        center: this.search_filters.location.center,
        zoom: this.search_filters.location
          ? this.search_filters.location.zoom
          : 11,
        maxZoom: 18,
        minZoom: 5,
        maxBounds: L.latLngBounds(corner1, corner2),
        layers: [
          street_layer,
        ],
      }).setView(
        this.search_filters.location
          ? this.search_filters.location.center
          : [initial_lat, initial_lng],
        this.search_filters.location ? this.search_filters.location.zoom : 11
      );
      
      this.map.on('locationfound', this.onLocationFound);
      this.map.on("moveend", () => {
        this.search_filters.region = "";
        this.search_filters.city = "";
        this.hover_cluster = false;
        global.emitter.emit("load_regions_n_cities");
        this.load_data();
      });
      var baseLayers = frappe.lang_dir=='ltr'?{
        "Map": street_layer,
        "Satellite": satellite_layer,
      }:{
        "الخريطة": street_layer,
        "القمر الصناعي": satellite_layer,
      };
      L.control.layers(baseLayers).addTo(this.map);
      //.........
      var customControl =  L.Control.extend({
        options: {
          position: 'topleft'
        },
        onAdd: this.createMapButton
      });
      this.map.addControl(new customControl());
      L.geoJSON(global.global_params.ksa_geo_json,{
          style: function (feature) {
              return {stroke: false, color: '#E8FFF0',fill: true, fillOpacity: 1};
          }
      }).addTo(this.map);
      //.........

      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      var paramEntries = urlParams.entries();
      var resetFilters = false;
      for (var entry of paramEntries) {
        if (this.search_filters[entry[0]] != undefined) {
          resetFilters = true;
          break;
        }
      }
      paramEntries = urlParams.entries();
      if (resetFilters) {
        global.reset_filters(this.search_filters);
        for (var entry of paramEntries) {
          if (this.search_filters[entry[0]] != undefined) {
            if (entry[0] == "region") {
              await global.global_params.get_regions();
              this.search_filters["region"] = global.global_params.get_region(entry[1]);
              this.region_changed();
            } else if (entry[0] == "agency") {
              this.search_filters["agency"] = entry[1];
            } else {
              this.search_filters[entry[0]] = entry[1];
            }
          }
        }
      }
      this.load_data();
    },
    clean_out_bound_markers: function () {
    },
    clean_markers: function () {
      for (let index = 0; index < this.clusters.length; index++) {
        this.map.removeLayer(this.clusters[index]["marker"]);
      }
      for (let index = 0; index < this.promoted_users.length; index++) {
        this.map.removeLayer(this.promoted_users[index]["marker"]);
      }
    },
    load_data: async function (refresh=true) {
      this.still_loading = true;
      if(refresh){
        this.refreshing_data = true;
        // global.emitter.emit("show-full-loading");
        this.page = 0;

      }
      let total_records_retrieved = 0;
      let container_size = this.map.getSize();
      let org_top_left = this.map.containerPointToLayerPoint(L.point(0, 0));
      let bleeding_area = {
        //LTR
        start: 150,
        end: 10,
        top: 30,
        bottom: 10,
      };
      if(frappe.lang_dir=="rtl"){
        bleeding_area = {
          //RTL
          start: 10,
          end: 150,
          top: 30,
          bottom: 10,
        };
      }
      org_bottom_left = L.point(
        org_top_left.x + bleeding_area.start,
        org_top_left.y + container_size.y - bleeding_area.bottom
      );
      org_top_right = L.point(
        org_top_left.x + container_size.x - bleeding_area.end,
        org_top_left.y + bleeding_area.top
      );
      let southWest = this.map.layerPointToLatLng(org_bottom_left);
      let northEast = this.map.layerPointToLatLng(org_top_right);
      let latlng_bounds = L.latLngBounds(southWest, northEast);
      try {
        let params = {
          north_east_lat: northEast.lat,
          north_east_lng: northEast.lng,
          south_west_lat: southWest.lat,
          south_west_lng: southWest.lng,
          filters: JSON.stringify(this.search_filters),
          page:this.page
        };
        // if(!refresh && this.refreshing_data){
        //   throw new TypeError();
        // }
        let res = await $.ajax({
          url: "/api/method/maalek.api.search_properties",
          type: "GET",
          data: params,
        });
        // if(!refresh && this.refreshing_data){
        //   throw new TypeError();
        // }
        total_records_retrieved = res.message["results"].length;
        if(refresh){
          this.page = 0;
          for (property_index in this.property_name_list) {
            this.property_list[property_index]["dirty"] = true;
          }
          this.clean_markers();
        }
        if (this.map.getZoom() >= this.big_lvl) {
          this.big_icon = true;
        } else {
          this.big_icon = false;
        }
        this.group_by = res.message["group_by"];
        if(this.group_by == 'property'){
          for (let index = 0; index < total_records_retrieved; index++) {
            var property = res.message["results"][index];
            var property_name = property['name'];
            if (this.property_name_list.includes(property_name)) {
              var p_index = this.property_name_list.indexOf(property_name);
              property["dirty"] = false;
              property["marker"] = this.property_list[p_index]["marker"];
              property["marker"].setIcon(this.normal_property_icon(property));
              this.property_list[p_index] = property;
              continue;
            }else{
              this.ad_type_count[property.ad_type]++;
              this.property_type_count[property.property_type]++;
              var propertyIcon = this.normal_property_icon(property);
              tmp_marker = L.marker([property.lat, property.lng], {
                icon: propertyIcon,
                opacity: this.normal_opacity,
                riseOnHover: true,
              })
                .on("click", (e) => {
                  this.markerOnClick(e.target.property);
                })
                .on("mouseover", (e) => {
                  this.hovered_property_type = null;
                  this.hovered_ad_type = null;
                  this.refresh_hovering(false, e.target.property);
                })
                .on("mouseout", (e) => {
                  this.hovered_property_type = null;
                  this.hovered_ad_type = null;
                  this.refresh_hovering(false);
                })
                .addTo(this.map);
              property["marker"] = tmp_marker;
              property["dirty"] = false;
              tmp_marker["property"] = property;
              this.property_list.push(property);
              this.property_name_list.push(property["name"]);
            }
          }
        }else{
          for (let index = 0; index < total_records_retrieved; index++) {
            let cluster = res.message["results"][index];
            var lat_lng;
            var tooltip = L.tooltip({
                permanent: true,
                direction: 'center',
                className: 'region-text'
            }).setContent(cluster.total_properties.toString());
            if(this.group_by == 'region'){
              region_data = global.global_params.get_region(cluster.region_id);
              var geo_json = JSON.parse(region_data.bounds);
              var latlngs = geo_json.features[0].geometry.coordinates[0][0];
              // lat_lng
              var polygon = L.geoJSON(geo_json,{
                  style: function (feature) {
                      return {color: region_data.color};
                  },
                  onEachFeature:function (feature, layer) {
                    layer.bindTooltip(tooltip);
                  }
              });
              cluster["marker"] = polygon
            }else{
              cluster["marker"] = L.circleMarker([cluster.center_lat, cluster.center_lng], {
                radius: this.group_by=='city'?24:40,
                opacity: 0.8,
                fillOpacity: 0.4,
                color: "#014116",
                fillColor: "#ffffff",
                weight: 2
              }).bindTooltip(tooltip);
            }
            cluster["marker"]["cluster"] = cluster;
            cluster["marker"].on("click", (e) => {
                this.map.setView([e.target.cluster.center_lat, e.target.cluster.center_lng], this.group_by=='city'?12:10);
              })
              .on("mouseover", (e) => {
                this.hover_cluster = e.target.cluster;
              })
              .on("mouseout", (e) => {
                this.hover_cluster = null;
              }).addTo(this.map);

            this.clusters.push(cluster);
          }
        }
        if(refresh){
          let users_res = await $.ajax({
            url: "/api/method/maalek.api.search_promoted_users",
            type: "GET",
            data: params,
          });
          this.promoted_users = [];
          for (let index = 0; index < users_res.message.length; index++) {
            var promoted_user = users_res.message[index];
            encodeURILogo = encodeURIComponent(promoted_user.logo);
            encodeURILogo = promoted_user.logo;
            promoted_user["marker"] = L.marker([promoted_user.lat, promoted_user.lng], {
                icon: L.divIcon({
                    className: "promoted-user", 
                    html:
                      '<div class="image-holder" style=\'background-image: url("'+promoted_user.logo+'");\'></div>',
                    iconAnchor: [15,30,],
                  }),
                opacity: this.normal_opacity,
                riseOnHover: true,
              }).on("click", (e) => {
                window.open("/user-catalogue/"+promoted_user.name,"_blank");
              }).addTo(this.map);
              promoted_user["marker"]["promoted_user"] = promoted_user;
            this.promoted_users.push(promoted_user);
          }
          if(this.group_by == 'property'){
            let mashros_data = await $.ajax({
              url: "/api/method/maalek.api.search_mashros",
              type: "GET",
              data: params,
            });
            for (let index = 0; index < this.mashros.length; index++) {
              this.mashros[index]["dirty"] = true;
            }
            for (let index = 0; index < mashros_data.message.length; index++) {
              var mashro = mashros_data.message[index];
              let skip = false;
              for (let p_index = 0; p_index < this.mashros.length; p_index++) {
                if(this.mashros[p_index]["name"] == mashro["name"]){
                  this.mashros[p_index]["dirty"] = false;
                  // this.mashros[p_index]["marker"].setIcon(this.normal_mashro_icon(mashro));
                  mashro["logo"] = this.mashros[p_index]["logo"];
                  mashro["marker"] = this.mashros[p_index]["marker"];
                  mashro["logo"].setIcon(this.normal_mashro_icon(mashro));
                  this.mashros[p_index] = mashro;
                  if(this.big_icon){
                    mashro["marker"].addTo(this.map);
                  }else{
                    this.map.removeLayer(mashro["marker"]);
                  }

                  skip = true;
                }
              }
              if(skip)
                continue;
              var geo_json = JSON.parse(mashro["location"]);
              var polygon = L.geoJSON(geo_json,{
                // pointToLayer:function (geoJsonPoint, latlng) {
                //   return L.marker(latlng);
                // }
                // onEachFeature:function (feature, layer) {
                //   layer.bindTooltip(tooltip);
                // }
              }).on("click", (e) => {
                  window.open("/project/"+mashro["name"],"_blank");
                });
              mashro["marker"] = polygon
              const proj_icon = this.normal_mashro_icon(mashro);
              mashro["logo"] = L.marker([mashro["lat"], mashro["lng"]], { icon: proj_icon });
              mashro["marker"]["mashro"] = mashro;
              mashro["logo"]["mashro"] = mashro;
              this.mashros.push(mashro);
              mashro["logo"].on("mouseover", (e) => {
                this.refresh_hovering(false, null, e.target.mashro);
              })
              .on("mouseout", (e) => {
                this.refresh_hovering(false);
              }).addTo(this.map);
              if(this.big_icon){
                mashro["marker"].addTo(this.map);
              }
              // this.map_marker = L.marker([initial_lat, initial_lng]);
              // this.markerLayerGroup.addLayer(this.map_marker);
            }

            for (let index = 0; index < this.mashros.length; index++) {
              if(this.mashros[index]["dirty"]){
                this.map.removeLayer(this.mashros[index]["marker"]);
                this.map.removeLayer(this.mashros[index]["logo"]);
                this.mashros.splice(index, 1);
              }
              // if(!this.big_icon){
              //   this.map.removeLayer(this.mashros[index]["marker"]);
              // }
            }
          }else{
            for (let index = 0; index < this.mashros.length; index++) {
              this.map.removeLayer(this.mashros[index]["marker"]);
              this.map.removeLayer(this.mashros[index]["logo"]);
            }
            this.mashros.splice(0, this.mashros.length);
          }
        }
        if(refresh){
          global.emitter.emit("refresh-property-component");
          global.emitter.emit("refresh_filters");
        }
        if (this.search_filters.location == undefined){
          this.search_filters.location = search_filters.location;
        }
        this.search_filters.location.zoom = 11;
        this.search_filters.location.center = [
          this.map.getCenter().lat,
          this.map.getCenter().lng
        ];
        this.search_filters.location.zoom = this.map.getZoom();
        localStorage.map_search_filters = JSON.stringify(this.search_filters);
        this.$forceUpdate();
      } catch (e) {
        console.log(e);
        if( !(e instanceof TypeError) ){
          var exceptions = helper.showException(e);
        }
      }
      if(refresh){
        // global.emitter.emit("hide-full-loading");
        this.refreshing_data = false;
      }
      this.is_ready = true;
      if(this.group_by == 'property' && total_records_retrieved != 0){
        this.page++;
        this.load_data(false);
      }else{
        var outbounded_properties = []
        for (var _i in this.property_name_list) {
          if(this.property_list[_i]["dirty"]){
            outbounded_properties.push(this.property_name_list[_i]);
          }
        }
        for (var _i in outbounded_properties) {
          var p_index = this.property_name_list.indexOf(outbounded_properties[_i]);
          this.ad_type_count[this.property_list[p_index].ad_type]--;
          this.property_type_count[this.property_list[p_index].property_type]--;
          this.map.removeLayer(this.property_list[p_index]["marker"]);
          this.property_list.splice(p_index, 1);
          this.property_name_list.splice(p_index, 1);
        }
        this.still_loading = false;
      }
    },
    markerOnClick: function (property) {
      if(this.selected_property == property){
        this.selected_property = null;
      }else{
        this.selected_property = property;
      }
    },
    propertyOnClick: function (property) {
      this.map.setView([property.marker.lat, property.marker.lng]);
    },
    refresh_hovering: function (clear = false, sl_property=null, sl_mashro=null) {
      this.mouseover_ad_type(clear);
      this.mouseover_property(clear,sl_property);
      this.mouseover_mashro(clear,sl_mashro);
      this.mouseover_property_type(clear);
    },
    big_div_icon: function (property, promote = false) {
      price =
        '<span dir="' +
        frappe.lang_dir +
        '">' +
        helper.nFormatter(property["total_price"]) +
        "</span>";
      return L.divIcon({
        className: "big-property-icon" + (promote?" promoted-property-icon":""),
        // [this.marker_width*this.promote_ratio, this.marker_height*this.promote_ratio]
        html:
          '<img src="' +
          global.global_params.map_icons[property.property_type][
            property.ad_type
          ] +
          '" style="width: ' +
          this.marker_width * this.promote_ratio +
          "px;height: " +
          this.marker_height * this.promote_ratio +
          'px;" />' +
          price,
        iconAnchor: [
          (this.marker_width * this.promote_ratio) / 2,
          this.marker_height * this.promote_ratio,
        ],
      });
    },
    normal_property_icon: function (property) {
      if (this.big_icon) {
        return this.big_div_icon(property);
      }
      return L.icon({
        iconUrl: global.global_params.map_icons["Default"][property.ad_type],
        iconSize: [this.default_marker_width, this.default_marker_height],
        iconAnchor: [this.default_marker_width / 2, this.default_marker_height],
        popupAnchor: [
          (this.marker_width * this.promote_ratio) / 2,
          -(this.marker_height * this.promote_ratio) / 2,
        ],
        tooltipAnchor: [
          (this.marker_width * this.promote_ratio) / 2,
          -(this.marker_height * this.promote_ratio) / 2,
        ],
      });
    },
    promote_property_marker: function (p_index,promote = false) {
      var icon = this.big_div_icon(this.property_list[p_index],promote);
      // this.property_list[p_index]["marker"].setOpacity(this.promote_opacity);
      this.property_list[p_index]["marker"].setIcon(icon);
      this.property_list[p_index]["marker"].setZIndexOffset(100);
    },
    dim_property_marker: function (p_index) {
      var icon = this.normal_property_icon(this.property_list[p_index]);
      // this.property_list[p_index]["marker"].setOpacity(this.dim_opacity);
      this.property_list[p_index]["marker"].setIcon(icon);
      this.property_list[p_index]["marker"].setZIndexOffset(0);
    },
    normal_property_marker: function (p_index) {
      var icon = this.normal_property_icon(this.property_list[p_index]);
      // this.property_list[p_index]["marker"].setOpacity(this.normal_opacity);
      this.property_list[p_index]["marker"].setIcon(icon);
      this.property_list[p_index]["marker"].setZIndexOffset(0);
    },
    // size_changed: function () {
    //   for (var _i in this.property_name_list) {
    //     this.normal_property_marker(_i);
    //   }
    //   this.$forceUpdate();
    // },
    mouseover_property_type: function (clear = false) {
      if (clear && this.hovered_property_type) {
        this.hovered_property_type = null;
      }
      if (this.hovered_property_type == this.prv_hovered_property_type) return;
      this.prv_hovered_property_type = this.hovered_property_type;
      for (var _i in this.property_name_list) {
        if (this.hovered_property_type == null) {
          this.normal_property_marker(_i);
        } else if (
          this.property_list[_i].property_type == this.hovered_property_type
        ) {
          this.promote_property_marker(_i,true);
        } else {
          this.dim_property_marker(_i);
        }
      }
      this.$forceUpdate();
    },
    mouseover_ad_type: function (clear = false) {
      if (clear && this.hovered_ad_type) {
        this.hovered_ad_type = null;
      }
      if (this.hovered_ad_type == this.prv_hovered_ad_type) return;
      this.prv_hovered_ad_type = this.hovered_ad_type;
      for (var _i in this.property_name_list) {
        if (this.hovered_ad_type == null) {
          this.normal_property_marker(_i);
        } else if (this.property_list[_i].ad_type == this.hovered_ad_type) {
          this.promote_property_marker(_i,true);
        } else {
          this.dim_property_marker(_i);
        }
      }
      this.$forceUpdate();
    },
    mouseover_property: function (clear = false,sl_property = null) {
      this.hovered_property = sl_property;
      if (clear && this.hovered_property) {
        this.hovered_property = null;
      }
      for (var _i in this.property_name_list) {
        if (this.hovered_property == null) {
          this.normal_property_marker(_i);
        } else if (this.property_list[_i] == this.hovered_property) {
          this.promote_property_marker(_i,true);
        } else {
          this.dim_property_marker(_i);
        }
      }
      this.$forceUpdate();
    },
    region_changed: function () {
      if (
        this.prv_region == this.search_filters.region ||
        this.search_filters.region == "" ||
        this.search_filters.region == null
      ) {
        return false;
      }
      this.prv_region = this.search_filters.region;
      this.search_filters.city = null;
      this.search_filters.district = null;
      var region =
        global.global_params.regions[
          global.global_params.region_indexes[
            this.search_filters.region.region_id
          ]
        ];
      var latlng = L.latLng(region.center[1], region.center[0]);
      this.map.setView([latlng.lat, latlng.lng], 12);
      return true;
    },
    city_changed: function () {
      if (
        this.prv_city == this.search_filters.city ||
        this.search_filters.city == "" ||
        this.search_filters.city == null
      ) {
        return false;
      }
      this.prv_city = this.search_filters.city;
      this.search_filters.district = null;
      // var city = global.global_params.cities[global.global_params.city_indexes[this.search_filters.city.cty_id]];
      var latlng = L.latLng(
        this.search_filters.city.center[1],
        this.search_filters.city.center[0]
      );
      this.map.setView([latlng.lat, latlng.lng], 12);
      return true;
    },
    district_changed: function () {
      if (
        this.prv_district == this.search_filters.district ||
        this.search_filters.district == "" ||
        this.search_filters.district == null
      ) {
        return false;
      }
      this.prv_district = this.search_filters.district;
      var district =
        global.global_params.districts[
          global.global_params.district_indexes[this.search_filters.district]
        ];
      var latlng = L.latLng(district.center[1], district.center[0]);
      this.map.setView([latlng.lat, latlng.lng], 12);
      return true;
    },
    refresh_page: function () {
      window.location.replace("/search");
    },
    big_mashro_div_icon: function (mashro, promote = false) {
      mashro_title = helper.truncateSafeText(mashro["title"],10);
      const textIcon = L.divIcon({
          className: 'custom-text-marker', // optional (can be empty)
          html: '<a href="/project/'+mashro["name"]+'" target="_BLANK" class="marker-label">'+mashro_title+' <i class="fa-solid fa-square-arrow-up-right"></i></a>',
          iconSize: [100, 30], // adjust based on content
          iconAnchor: [50, 15] // center it
      });
      return textIcon;
    },
    normal_mashro_icon: function (mashro) {
      if (this.big_icon) {
        return this.big_mashro_div_icon(mashro);
      }
      return L.icon({
        iconUrl: global.global_params.map_icons["Mashro"],
        iconSize: [this.default_marker_width, this.default_marker_height],
        iconAnchor: [(this.default_marker_width)/2, this.default_marker_height],
        popupAnchor: [
          (this.marker_width * this.promote_ratio) / 2,
          -(this.marker_height * this.promote_ratio) / 2,
        ],
        tooltipAnchor: [
          (this.marker_width * this.promote_ratio) / 2,
          -(this.marker_height * this.promote_ratio) / 2,
        ],
      });
    },
    promote_mashro_marker: function (p_index,promote = false) {
      var icon = this.big_mashro_div_icon(this.mashros[p_index],promote);
      this.mashros[p_index]["logo"].setIcon(icon);
      this.mashros[p_index]["logo"].setZIndexOffset(100);
    },
    normal_mashro_marker: function (p_index) {
      var icon = this.normal_mashro_icon(this.mashros[p_index]);
      this.mashros[p_index]["logo"].setIcon(icon);
      this.mashros[p_index]["logo"].setZIndexOffset(0);
    },
    mouseover_mashro: function (clear = false,sl_mashro = null) {
      this.hovered_mashro = sl_mashro;
      if (clear && this.hovered_mashro) {
        this.hovered_mashro = null;
      }
      for (var _i in this.mashros) {
        if (this.hovered_mashro == null) {
          this.normal_mashro_marker(_i);
        } else if (this.mashros[_i] == this.hovered_mashro) {
          this.promote_mashro_marker(_i,true);
        }
      }
      this.$forceUpdate();
    },
    
  },
  computed: {},
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app-search-page" } }, [
    _c("div", { staticClass: "listing-map-area vh-100 vw-100" }, [
      _c(
        "div",
        { staticClass: "row vh-100" },
        [
          _c("div", { staticClass: "col-lg-8 vh-100" }, [
            _c(
              "div",
              { staticClass: "progress", staticStyle: { height: "4px" } },
              [
                _vm.still_loading
                  ? _c("div", {
                      staticClass: "progress-bar",
                      staticStyle: { width: "100%" },
                      attrs: {
                        role: "progressbar",
                        "aria-valuenow": "100",
                        "aria-valuemin": "0",
                        "aria-valuemax": "100"
                      }
                    })
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "map-wrap vh-100" }, [
              _c("div", { staticClass: "vh-100", attrs: { id: "map" } }),
              _vm._v(" "),
              _vm.property_name_list.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "legend",
                      on: {
                        mouseleave: function($event) {
                          return _vm.refresh_hovering(true)
                        }
                      }
                    },
                    [
                      _c("h4", [_vm._v(_vm._s(_vm.helper.t("Legends")))]),
                      _vm._v(" "),
                      _c(
                        "table",
                        [
                          _vm._l(_vm.ad_type_count, function(count, ad_type) {
                            return count > 0
                              ? _c(
                                  "tr",
                                  {
                                    on: {
                                      mouseover: function($event) {
                                        $event.preventDefault()
                                        _vm.hovered_ad_type = ad_type
                                        _vm.hovered_property_type = null
                                        _vm.hovered_property = null
                                        _vm.refresh_hovering(false)
                                      }
                                    }
                                  },
                                  [
                                    _c("td", [
                                      _c("i", {
                                        staticClass: "fa-solid fa-circle",
                                        staticStyle: { "line-height": "22px" },
                                        style: {
                                          color:
                                            _vm.global.global_params
                                              .ad_type_colors[ad_type]
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.helper.t(ad_type)))
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "count" }, [
                                      _vm._v(_vm._s(count))
                                    ])
                                  ]
                                )
                              : _vm._e()
                          }),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _vm._l(_vm.property_type_count, function(
                            count,
                            property_type
                          ) {
                            return count > 0
                              ? _c(
                                  "tr",
                                  {
                                    on: {
                                      mouseover: function($event) {
                                        $event.preventDefault()
                                        _vm.hovered_property_type = property_type
                                        _vm.hovered_ad_type = null
                                        _vm.hovered_property = null
                                        _vm.refresh_hovering(false)
                                      }
                                    }
                                  },
                                  [
                                    _c("td", [
                                      _c("img", {
                                        attrs: {
                                          src:
                                            _vm.global.global_params
                                              .legend_icons[property_type]
                                        }
                                      }),
                                      _c("span", { staticClass: "px-1" }, [
                                        _vm._v(
                                          _vm._s(_vm.helper.t(property_type))
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "count" }, [
                                      _vm._v(_vm._s(count))
                                    ])
                                  ]
                                )
                              : _vm._e()
                          })
                        ],
                        2
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hover_cluster
                ? _c("div", { staticClass: "legend" }, [
                    _c("h4", [_vm._v(_vm._s(_vm.helper.t("Legends")))]),
                    _vm._v(" "),
                    _c(
                      "table",
                      [
                        _vm.hover_cluster.rent > 0
                          ? _c("tr", [
                              _c("td", [
                                _c("i", {
                                  staticClass: "fa-solid fa-circle",
                                  staticStyle: { "line-height": "22px" },
                                  style: {
                                    color:
                                      _vm.global.global_params.ad_type_colors[
                                        "Rent"
                                      ]
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.helper.t("Rent")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "count" }, [
                                _vm._v(_vm._s(_vm.hover_cluster.rent))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hover_cluster.sale > 0
                          ? _c("tr", [
                              _c("td", [
                                _c("i", {
                                  staticClass: "fa-solid fa-circle",
                                  staticStyle: { "line-height": "22px" },
                                  style: {
                                    color:
                                      _vm.global.global_params.ad_type_colors[
                                        "Sale"
                                      ]
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.helper.t("Sale")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "count" }, [
                                _vm._v(_vm._s(_vm.hover_cluster.sale))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("hr"),
                        _vm._v(" "),
                        _vm._l(
                          [
                            "Apartment",
                            "Floor",
                            "Warehouse",
                            "Villa",
                            "House",
                            "Building",
                            "Chalet",
                            "Camp",
                            "Farm",
                            "Land",
                            "Shop / Office"
                          ],
                          function(property_type) {
                            return _vm.hover_cluster[property_type] > 0
                              ? _c("tr", [
                                  _c("td", [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          _vm.global.global_params.legend_icons[
                                            property_type
                                          ]
                                      }
                                    }),
                                    _c("span", { staticClass: "px-1" }, [
                                      _vm._v(
                                        _vm._s(_vm.helper.t(property_type))
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "count" }, [
                                    _vm._v(
                                      _vm._s(_vm.hover_cluster[property_type])
                                    )
                                  ])
                                ])
                              : _vm._e()
                          }
                        )
                      ],
                      2
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-4 g-0" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex align-items-end flex-column bd-highlight mb-3 vh-100 pe-3",
                staticStyle: { "overflow-y": "hidden" }
              },
              [
                _vm.property_name_list.length == 0
                  ? _c("div", { staticClass: "w-100 text-center pt-4" }, [
                      _c("p", { staticClass: "m-0" }, [
                        _vm._v(
                          _vm._s(
                            _vm.helper.t(
                              "No property found under this criteria"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "btn default-btn",
                          attrs: { href: "/account/add-property" }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.helper.t("Add Property")) +
                              "\n            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "m-0" }, [
                        _vm._v(
                          _vm._s(
                            _vm.helper.t(
                              "Be the first to create property in this area"
                            )
                          )
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.selected_property
                  ? _c(
                      "div",
                      {
                        key: _vm.selected_property.name,
                        staticClass: "single-list-property selected",
                        staticStyle: { width: "100%" },
                        attrs: { id: _vm.selected_property.name },
                        on: {
                          mouseover: function($event) {
                            _vm.hovered_property_type = null
                            _vm.hovered_ad_type = null
                            _vm.refresh_hovering(false, _vm.selected_property)
                          },
                          mouseleave: function($event) {
                            return _vm.refresh_hovering(true)
                          }
                        }
                      },
                      [
                        _c("property_component_horizontal", {
                          attrs: {
                            property_data: _vm.selected_property,
                            can_observe: true
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "align-items-center",
                    attrs: { id: "list-properties" }
                  },
                  _vm._l(_vm.property_list, function(property) {
                    return property != _vm.selected_property
                      ? _c(
                          "div",
                          {
                            key: property.name,
                            staticClass: "single-list-property",
                            attrs: { id: property.name },
                            on: {
                              mouseover: function($event) {
                                _vm.hovered_property_type = null
                                _vm.hovered_ad_type = null
                                _vm.refresh_hovering(false, property)
                              },
                              mouseleave: function($event) {
                                _vm.hovered_property_type = null
                                _vm.hovered_ad_type = null
                                _vm.refresh_hovering(true)
                              }
                            }
                          },
                          [
                            _c("property_component_horizontal", {
                              attrs: {
                                property_data: property,
                                can_observe: true
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  }),
                  0
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("search_filters_modal", {
            attrs: { search_filters_prop: _vm.search_filters }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "listing-location-area bg-color-f1f8f9" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("form", { staticClass: "form-listing-map" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                { staticClass: "d-flex justify-content-end" },
                [
                  _vm.agency_name
                    ? _c(
                        "div",
                        {
                          staticClass: "btn-group me-2 me-auto",
                          attrs: { role: "group" }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.refresh_page()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(_vm.agency_name) +
                                  "\n                  "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.refresh_page()
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa-solid fa-xmark" })]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("filter_tablets_component", {
                    attrs: { search_filters_prop: _vm.search_filters }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "btn-toolbar",
                      attrs: {
                        role: "toolbar",
                        "aria-label": "Toolbar with button groups"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "btn-group",
                          attrs: { role: "group", "aria-label": "Third group" }
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary",
                              attrs: {
                                type: "button",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#searchFiltersModal"
                              }
                            },
                            [
                              _c("i", { staticClass: "fa-solid fa-sliders" }),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.helper.t("Filters")) +
                                  "\n                  "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-5969fb92_0", { source: "\nhr {\r\n  margin: 0 !important;\n}\ntable td {\r\n  padding: 0 5px;\n}\n.legend {\r\n  padding: 6px 4px;\r\n  font-size: 14px;\r\n  background: rgba(255, 255, 255, 0.4);\r\n  line-height: 24px;\r\n  color: #555;\r\n  z-index: 2000;\r\n  bottom: 0;\r\n  position: absolute;\n}\n.legend tr {\r\n  cursor: pointer;\n}\n.legend:hover {\r\n  background: white;\n}\n.legend h4 {\r\n  text-align: center;\r\n  font-size: 16px;\r\n  margin: 2px 12px 8px;\r\n  color: #777;\n}\n.legend img {\r\n  width: 20px;\r\n  height: 24px;\n}\n.legend i {\r\n  width: 18px;\r\n  height: 18px;\r\n  float: left;\r\n  margin: 0 8px 0 0;\r\n  opacity: 0.7;\n}\n.legend i.icon {\r\n  background-size: 18px;\r\n  background-color: rgba(255, 255, 255, 1);\n}\n.single-agents-details .deborah-wrap {\r\n  padding: 10px;\n}\n.big-property-icon {\r\n  width: max-content !important;\r\n  height: max-content !important;\r\n  direction: ltr;\n}\n.big-property-icon img {\r\n  margin-right: 2px;\n}\n.big-property-icon span,\r\n.big-property-icon p {\r\n  font-size: 1.2em;\r\n  background-color: white;\r\n  padding: 0 5px;\r\n  border: 1px solid transparent;\r\n  border-color: black;\r\n  border-radius: 10px 10px 10px 0px;\n}\n#list-properties {\r\n  overflow-x: hidden;\r\n  overflow-y: scroll;\r\n  width: 100%;\r\n  padding-bottom: 10em;\r\n  -ms-overflow-style: none; /* Internet Explorer 10+ */\r\n  scrollbar-width: none; /* Firefox */\n}\n#list-properties::-webkit-scrollbar {\r\n  display: none; /* Safari and Chrome */\n}\n.map-button{\r\n  border: 2px solid rgba(0, 0, 0, 0.2);\r\n  border-radius: 4px;\n}\n.leaflet-tooltip-pane{\r\n  direction: ltr;\n}\n.leaflet-tooltip-pane .text {\r\n  color: #014116; \r\n  font-weight: bold;\r\n  background: transparent;\r\n  border:0;\r\n  box-shadow: none;\r\n  font-size:1.6em;\n}\n.leaflet-tooltip-pane .region-text {\r\n  color: #014116; \r\n  font-weight: bold;\r\n  background: transparent;\r\n  border:0;\r\n  box-shadow: none;\r\n  font-size:3em;\n}\n.promoted-user{\r\n  background-color: white;\r\n  width: 30px !important;\r\n  height: 30px !important;\n}\n.promoted-user .image-holder{\r\n  display: block;\r\n  padding-top: 100%;\r\n  width: 30px;\r\n  height: 30px;\r\n  background-repeat: no-repeat;\r\n  background-size: contain;\r\n  background-position: center;\n}\n.promoted-property-icon span{\r\n  background-color: #014116;\r\n  color: #fff;\n}\n.marker-label{\r\n  padding: 0px 10px;\r\n  background-color: black;\r\n  text-align: center;\r\n  color: white !important;\r\n  border-radius: 5px;\n}\n.marker-label:hover{\r\n  background-color: #014116;\r\n  color: white !important;\n}\n.marker-label:hover *{\r\n  color: white !important;\n}\r\n", map: {"version":3,"sources":["../maalek/maalek/public/vue/widgets/map-search-widget.vue"],"names":[],"mappings":";AAmhCA;EACA,oBAAA;AACA;AACA;EACA,cAAA;AACA;AACA;EACA,gBAAA;EACA,eAAA;EACA,oCAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;AACA;AACA;EACA,eAAA;AACA;AACA;EACA,iBAAA;AACA;AACA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AACA;AAEA;EACA,WAAA;EACA,YAAA;AACA;AAEA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AACA;AAEA;EACA,qBAAA;EACA,wCAAA;AACA;AAEA;EACA,aAAA;AACA;AAEA;EACA,6BAAA;EACA,8BAAA;EACA,cAAA;AACA;AACA;EACA,iBAAA;AACA;AACA;;EAEA,gBAAA;EACA,uBAAA;EACA,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,iCAAA;AACA;AAEA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,wBAAA,EAAA,0BAAA;EACA,qBAAA,EAAA,YAAA;AACA;AACA;EACA,aAAA,EAAA,sBAAA;AACA;AACA;EACA,oCAAA;EACA,kBAAA;AACA;AACA;EACA,cAAA;AACA;AACA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;AACA;AACA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,aAAA;AACA;AAEA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;AACA;AAEA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;AACA;AAEA;EACA,yBAAA;EACA,WAAA;AACA;AAEA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;AACA;AAEA;EACA,yBAAA;EACA,uBAAA;AACA;AAEA;EACA,uBAAA;AACA","file":"map-search-widget.vue","sourcesContent":["<template>\r\n  <div id=\"app-search-page\">\r\n    <!-- End Listing (Column Map) Area -->\r\n    <div class=\"listing-map-area vh-100 vw-100\">\r\n      <div class=\"row vh-100\">\r\n        <div class=\"col-lg-8 vh-100\">\r\n          <div class=\"progress\" style=\"height: 4px;\">\r\n            <div v-if=\"still_loading\" class=\"progress-bar\" role=\"progressbar\" style=\"width: 100%\" aria-valuenow=\"100\" aria-valuemin=\"0\" aria-valuemax=\"100\"></div>\r\n          </div>\r\n          <div class=\"map-wrap vh-100\">\r\n            <div class=\"vh-100\" id=\"map\"></div>\r\n            <div v-if=\"property_name_list.length > 0\" class=\"legend\" @mouseleave=\"refresh_hovering(true)\">\r\n              <h4>{{ helper.t(\"Legends\") }}</h4>\r\n              <table>\r\n                <tr\r\n                  v-for=\"(count, ad_type) in ad_type_count\"\r\n                  v-if=\"count > 0\"\r\n                  @mouseover.prevent=\"\r\n                    hovered_ad_type = ad_type;\r\n                    hovered_property_type = null;\r\n                    hovered_property = null;\r\n                    refresh_hovering(false);\r\n                  \"\r\n                >\r\n                  <td>\r\n                    <i\r\n                      class=\"fa-solid fa-circle\"\r\n                      style=\"line-height: 22px\"\r\n                      :style=\"{\r\n                        color: global.global_params.ad_type_colors[ad_type],\r\n                      }\"\r\n                    ></i>\r\n                    <span>{{ helper.t(ad_type) }}</span>\r\n                  </td>\r\n                  <td class=\"count\">{{ count }}</td>\r\n                </tr>\r\n                <hr />\r\n                <tr\r\n                  v-for=\"(count, property_type) in property_type_count\"\r\n                  v-if=\"count > 0\"\r\n                  @mouseover.prevent=\"\r\n                    hovered_property_type = property_type;\r\n                    hovered_ad_type = null;\r\n                    hovered_property = null;\r\n                    refresh_hovering(false);\r\n                  \"\r\n                >\r\n                  <td>\r\n                    <img\r\n                      :src=\"global.global_params.legend_icons[property_type]\"\r\n                    /><span class=\"px-1\">{{ helper.t(property_type) }}</span>\r\n                  </td>\r\n                  <td class=\"count\">{{ count }}</td>\r\n                </tr>\r\n              </table>\r\n            </div>\r\n            <div v-if=\"hover_cluster\" class=\"legend\">\r\n              <h4>{{ helper.t(\"Legends\") }}</h4>\r\n              <table>\r\n                <tr v-if=\"hover_cluster.rent > 0\" >\r\n                  <td>\r\n                    <i\r\n                      class=\"fa-solid fa-circle\"\r\n                      style=\"line-height: 22px\"\r\n                      :style=\"{\r\n                        color: global.global_params.ad_type_colors['Rent'],\r\n                      }\"\r\n                    ></i>\r\n                    <span>{{ helper.t(\"Rent\") }}</span>\r\n                  </td>\r\n                  <td class=\"count\">{{ hover_cluster.rent }}</td>\r\n                </tr>\r\n                <tr v-if=\"hover_cluster.sale > 0\" >\r\n                  <td>\r\n                    <i\r\n                      class=\"fa-solid fa-circle\"\r\n                      style=\"line-height: 22px\"\r\n                      :style=\"{\r\n                        color: global.global_params.ad_type_colors['Sale'],\r\n                      }\"\r\n                    ></i>\r\n                    <span>{{ helper.t(\"Sale\") }}</span>\r\n                  </td>\r\n                  <td class=\"count\">{{ hover_cluster.sale }}</td>\r\n                </tr>\r\n                <hr />\r\n                <tr\r\n                  v-for='property_type in [\"Apartment\",\"Floor\",\"Warehouse\",\"Villa\",\"House\",\"Building\",\"Chalet\",\"Camp\",\"Farm\",\"Land\",\"Shop / Office\"]'\r\n                  v-if=\"hover_cluster[property_type] > 0\">\r\n                  <td>\r\n                    <img\r\n                      :src=\"global.global_params.legend_icons[property_type]\"\r\n                    /><span class=\"px-1\">{{ helper.t(property_type) }}</span>\r\n                  </td>\r\n                  <td class=\"count\">{{ hover_cluster[property_type] }}</td>\r\n                </tr>\r\n              </table>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-lg-4 g-0\">\r\n          <div\r\n            class=\"d-flex align-items-end flex-column bd-highlight mb-3 vh-100 pe-3\"\r\n            style=\"overflow-y: hidden\"\r\n          >\r\n            <div v-if=\"property_name_list.length == 0\" class=\"w-100 text-center pt-4\">\r\n              <p class=\"m-0\">{{ helper.t(\"No property found under this criteria\") }}</p>\r\n              <a href=\"/account/add-property\" class=\"btn default-btn\">\r\n                {{ helper.t(\"Add Property\") }}\r\n              </a>\r\n              <p class=\"m-0\">{{ helper.t(\"Be the first to create property in this area\") }}</p>\r\n            </div>\r\n            <div\r\n              v-if=\"selected_property\"\r\n              class=\"single-list-property selected\"\r\n              style=\"width: 100%\"\r\n              :id=\"selected_property.name\"\r\n              :key=\"selected_property.name\"\r\n              @mouseover=\"\r\n                hovered_property_type = null;\r\n                hovered_ad_type = null;\r\n                refresh_hovering(false, selected_property);\r\n              \"\r\n              @mouseleave=\"refresh_hovering(true)\"\r\n            >\r\n              <property_component_horizontal\r\n                :property_data=\"selected_property\"\r\n                :can_observe =\"true\"\r\n              ></property_component_horizontal>\r\n            </div>\r\n            <div class=\"align-items-center\" id=\"list-properties\">\r\n              <div\r\n                class=\"single-list-property\"\r\n                v-for=\"property in property_list\"\r\n                v-if=\"property != selected_property\"\r\n                :id=\"property.name\"\r\n                :key=\"property.name\"\r\n                @mouseover=\"\r\n                  hovered_property_type = null;\r\n                  hovered_ad_type = null;\r\n                  refresh_hovering(false, property);\r\n                \"\r\n                @mouseleave=\"\r\n                  hovered_property_type = null;\r\n                  hovered_ad_type = null;\r\n                  refresh_hovering(true);\r\n                \"\r\n              >\r\n                <property_component_horizontal\r\n                  :property_data=\"property\"\r\n                  :can_observe =\"true\"\r\n                ></property_component_horizontal>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <!-- Modal -->\r\n        <search_filters_modal\r\n          :search_filters_prop=\"search_filters\"\r\n        ></search_filters_modal>\r\n        <!-- Modal -->\r\n      </div>\r\n    </div>\r\n    <!-- End Listing (Column Map) Area -->\r\n\r\n    <!-- Start Listing Area -->\r\n    <div class=\"listing-location-area bg-color-f1f8f9\">\r\n      <div class=\"container-fluid\">\r\n        <form class=\"form-listing-map\">\r\n          <div class=\"row\">\r\n            <div class=\"col-12\">\r\n              <div class=\"d-flex justify-content-end\">\r\n                <div v-if=\"agency_name\" class=\"btn-group me-2 me-auto\" role=\"group\">\r\n                    <button type=\"button\" class=\"btn btn-primary\" @click.prevent=\"refresh_page()\">\r\n                        {{ agency_name }}\r\n                    </button>\r\n                    <button type=\"button\" class=\"btn btn-primary\" @click.prevent=\"refresh_page()\">\r\n                        <i class=\"fa-solid fa-xmark\"></i>\r\n                    </button>\r\n                </div>\r\n                <filter_tablets_component :search_filters_prop=\"search_filters\">\r\n                </filter_tablets_component>\r\n                <div\r\n                  class=\"btn-toolbar\"\r\n                  role=\"toolbar\"\r\n                  aria-label=\"Toolbar with button groups\"\r\n                >\r\n                  <div class=\"btn-group\" role=\"group\" aria-label=\"Third group\">\r\n                    <button\r\n                      type=\"button\"\r\n                      class=\"btn btn-outline-secondary\"\r\n                      data-bs-toggle=\"modal\"\r\n                      data-bs-target=\"#searchFiltersModal\"\r\n                    >\r\n                      <i class=\"fa-solid fa-sliders\"></i>\r\n                      {{ helper.t(\"Filters\") }}\r\n                    </button>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n    <!-- End Listing Area -->\r\n  </div>\r\n</template>\r\n\r\n<script>\r\nimport * as global from \"../../js/global\";\r\nimport * as helper from \"../../js/helper\";\r\nimport full_loading from \"../components/full-loading.vue\";\r\nimport property_component_horizontal from \"../components/property-component-horizontal.vue\";\r\nimport search_filters_modal from \"../modal/search-filters-modal.vue\";\r\nimport filter_tablets_component from \"../components/filter-tablets-component.vue\";\r\nexport default {\r\n  components: {\r\n    full_loading: full_loading,\r\n    property_component_horizontal: property_component_horizontal,\r\n    search_filters_modal: search_filters_modal,\r\n    filter_tablets_component: filter_tablets_component,\r\n  },\r\n  name: \"map_search_widget\",\r\n  props: {\r\n    agency_name: {\r\n        default: null,\r\n    },\r\n  },\r\n  data() {\r\n    return {\r\n      is_ready:false,\r\n      global,\r\n      helper,\r\n      frappe,\r\n      search_filters: localStorage.map_search_filters\r\n        ? JSON.parse(localStorage.map_search_filters)\r\n        : global.search_filters,\r\n      default_marker_width: 11,\r\n      default_marker_height: 11,\r\n      marker_width: 28,\r\n      marker_height: 34,\r\n      promote_ratio: 1,\r\n      promote_opacity: 1,\r\n      dim_opacity: 0.4,\r\n      normal_opacity: 1,\r\n      map: null,\r\n      target_latlng: null,\r\n      mashros: [],\r\n      promoted_users: [],\r\n      page: 0,\r\n      refreshing_data: false,\r\n      still_loading: false,\r\n      property_name_list: [],\r\n      property_list: [],\r\n      clusters: [],\r\n      group_by: 'property',\r\n      hover_cluster:null,\r\n      selected_property: null,\r\n      hovered_mashro: null,\r\n      hovered_property: null,\r\n      hovered_property_type: null,\r\n      prv_hovered_property_type: null,\r\n      hovered_ad_type: null,\r\n      prv_hovered_ad_type: null,\r\n      prv_region: null,\r\n      prv_city: null,\r\n      prv_district: null,\r\n      prv_zoom: null,\r\n      big_lvl: 14,\r\n      big_icon: false,\r\n      property_type_count: {\r\n        Apartment: 0,\r\n      },\r\n      ad_type_count: {\r\n        Rent: 0,\r\n        Sale: 0,\r\n        Auction: 0,\r\n      },\r\n    };\r\n  },\r\n  async mounted() {\r\n    this.checkFilterStructureUpdate();\r\n    for (var _property_type of global.property_constants.property_keys) {\r\n      this.property_type_count[_property_type] = 0\r\n    }\r\n    global.emitter.emit(\"show-full-loading\");\r\n    this.getCurrentPosition();\r\n    global.emitter.on(\"load-search-again\", (args) => {\r\n      var is_any_change = false;\r\n      if (!this.region_changed()) {\r\n        // is_any_change = true;\r\n      }\r\n      if (!this.city_changed()) {\r\n        // is_any_change = true;\r\n      }\r\n      if (!this.district_changed()) {\r\n        // is_any_change = true;\r\n      }\r\n      if (is_any_change || true) {\r\n        this.load_data();\r\n      }\r\n    });\r\n  },\r\n  methods: {\r\n    checkFilterStructureUpdate: function (){\r\n      const keys1 = Object.keys(global.search_filters);\r\n      const keys2 = Object.keys(this.search_filters);\r\n      if (keys1.length !== keys2.length){\r\n        this.search_filters = global.search_filters;\r\n      }else if(!keys1.every(key => keys2.includes(key))){\r\n        this.search_filters = global.search_filters;\r\n      }\r\n      if(!this.agency_name){\r\n        this.search_filters.agency = \"\";\r\n      }\r\n    },\r\n    getCurrentPosition: function (){\r\n      navigator.geolocation.getCurrentPosition(this.getCurrentPositionSuccess,this.getCurrentPositionError);\r\n    },\r\n    getCurrentPositionSuccess: function (position) {\r\n      if(!this.is_ready){\r\n        this.setup_things([position.coords.latitude, position.coords.longitude]);\r\n      }else{\r\n        this.search_filters.region = \"\"\r\n        this.search_filters.city = \"\"\r\n        global.emitter.emit(\"load_regions_n_cities\");\r\n        this.map.setView([position.coords.latitude, position.coords.longitude], 12);\r\n      }\r\n    },\r\n    getCurrentPositionError: function () {\r\n      if(!this.is_ready){\r\n        this.setup_things();\r\n      }\r\n    },\r\n    onLocationFound: function(e) {\r\n      var radius = e.accuracy;\r\n\r\n      L.marker(e.latlng).addTo(map)\r\n          .bindPopup(\"You are within \" + radius + \" meters from this point\").openPopup();\r\n\r\n      L.circle(e.latlng, radius).addTo(map);\r\n    },\r\n    createMapButton: function (map) {\r\n      var container = L.DomUtil.create('button',\"map-button\");\r\n      container.type=\"button\"\r\n      container.innerHTML = '<i class=\"fa-solid fa-location-crosshairs\"></i>';\r\n\r\n      container.style.backgroundColor = 'white';\r\n      container.style.width = '32px';\r\n      container.style.height = '32px';\r\n      \r\n      container.onmouseover = function(){\r\n        container.style.backgroundColor = '#f4f4f4'; \r\n      }\r\n      container.onmouseout = function(){\r\n        container.style.backgroundColor = 'white'; \r\n      }\r\n\r\n      container.onclick = this.getCurrentPosition;\r\n\r\n      return container;\r\n    },\r\n    setup_things: async function (initial_lat_lng = [24.69999996, 46.73333003]) {\r\n      var initial_lat = initial_lat_lng[0];\r\n      var initial_lng = initial_lat_lng[1];\r\n      let corner1 = L.latLng(32.896210012370656, 33.96066018865814);\r\n      let corner2 = L.latLng(15.613607036429755, 55.8301100044458);\r\n      if(this.search_filters.location == null){\r\n        this.search_filters.location = {\r\n          center: [initial_lat, initial_lng],\r\n          zoom: 11,\r\n        }\r\n      }\r\n\r\n      var satellite_layer = L.tileLayer(\r\n        \"/api/method/maalek.api.geo_api.get_tile?type=satellite&z={z}&x={x}&y={y}\",\r\n        {\r\n          attribution: '&copy; <a href=\"https://maalek.net\">Maalek.Net</a>',\r\n          \r\n        }\r\n      );\r\n      var street_layer = L.tileLayer(\r\n        \"/api/method/maalek.api.geo_api.get_tile?type=light&z={z}&x={x}&y={y}\",\r\n        {\r\n          attribution: '&copy; <a href=\"https://maalek.net\">Maalek.Net</a>',\r\n        }\r\n      );\r\n      this.map = L.map(\"map\", {\r\n        center: this.search_filters.location.center,\r\n        zoom: this.search_filters.location\r\n          ? this.search_filters.location.zoom\r\n          : 11,\r\n        maxZoom: 18,\r\n        minZoom: 5,\r\n        maxBounds: L.latLngBounds(corner1, corner2),\r\n        layers: [\r\n          street_layer,\r\n        ],\r\n      }).setView(\r\n        this.search_filters.location\r\n          ? this.search_filters.location.center\r\n          : [initial_lat, initial_lng],\r\n        this.search_filters.location ? this.search_filters.location.zoom : 11\r\n      );\r\n      \r\n      this.map.on('locationfound', this.onLocationFound);\r\n      this.map.on(\"moveend\", () => {\r\n        this.search_filters.region = \"\";\r\n        this.search_filters.city = \"\";\r\n        this.hover_cluster = false;\r\n        global.emitter.emit(\"load_regions_n_cities\");\r\n        this.load_data();\r\n      });\r\n      var baseLayers = frappe.lang_dir=='ltr'?{\r\n        \"Map\": street_layer,\r\n        \"Satellite\": satellite_layer,\r\n      }:{\r\n        \"الخريطة\": street_layer,\r\n        \"القمر الصناعي\": satellite_layer,\r\n      };\r\n      L.control.layers(baseLayers).addTo(this.map);\r\n      //.........\r\n      var customControl =  L.Control.extend({\r\n        options: {\r\n          position: 'topleft'\r\n        },\r\n        onAdd: this.createMapButton\r\n      });\r\n      this.map.addControl(new customControl());\r\n      L.geoJSON(global.global_params.ksa_geo_json,{\r\n          style: function (feature) {\r\n              return {stroke: false, color: '#E8FFF0',fill: true, fillOpacity: 1};\r\n          }\r\n      }).addTo(this.map);\r\n      //.........\r\n\r\n      var queryString = window.location.search;\r\n      var urlParams = new URLSearchParams(queryString);\r\n      var paramEntries = urlParams.entries();\r\n      var resetFilters = false;\r\n      for (var entry of paramEntries) {\r\n        if (this.search_filters[entry[0]] != undefined) {\r\n          resetFilters = true;\r\n          break;\r\n        }\r\n      }\r\n      paramEntries = urlParams.entries();\r\n      if (resetFilters) {\r\n        global.reset_filters(this.search_filters);\r\n        for (var entry of paramEntries) {\r\n          if (this.search_filters[entry[0]] != undefined) {\r\n            if (entry[0] == \"region\") {\r\n              await global.global_params.get_regions();\r\n              this.search_filters[\"region\"] = global.global_params.get_region(entry[1]);\r\n              this.region_changed();\r\n            } else if (entry[0] == \"agency\") {\r\n              this.search_filters[\"agency\"] = entry[1];\r\n            } else {\r\n              this.search_filters[entry[0]] = entry[1];\r\n            }\r\n          }\r\n        }\r\n      }\r\n      this.load_data();\r\n    },\r\n    clean_out_bound_markers: function () {\r\n    },\r\n    clean_markers: function () {\r\n      for (let index = 0; index < this.clusters.length; index++) {\r\n        this.map.removeLayer(this.clusters[index][\"marker\"]);\r\n      }\r\n      for (let index = 0; index < this.promoted_users.length; index++) {\r\n        this.map.removeLayer(this.promoted_users[index][\"marker\"]);\r\n      }\r\n    },\r\n    load_data: async function (refresh=true) {\r\n      this.still_loading = true;\r\n      if(refresh){\r\n        this.refreshing_data = true;\r\n        // global.emitter.emit(\"show-full-loading\");\r\n        this.page = 0;\r\n\r\n      }\r\n      let total_records_retrieved = 0;\r\n      let container_size = this.map.getSize();\r\n      let org_top_left = this.map.containerPointToLayerPoint(L.point(0, 0));\r\n      let bleeding_area = {\r\n        //LTR\r\n        start: 150,\r\n        end: 10,\r\n        top: 30,\r\n        bottom: 10,\r\n      };\r\n      if(frappe.lang_dir==\"rtl\"){\r\n        bleeding_area = {\r\n          //RTL\r\n          start: 10,\r\n          end: 150,\r\n          top: 30,\r\n          bottom: 10,\r\n        };\r\n      }\r\n      org_bottom_left = L.point(\r\n        org_top_left.x + bleeding_area.start,\r\n        org_top_left.y + container_size.y - bleeding_area.bottom\r\n      );\r\n      org_top_right = L.point(\r\n        org_top_left.x + container_size.x - bleeding_area.end,\r\n        org_top_left.y + bleeding_area.top\r\n      );\r\n      let southWest = this.map.layerPointToLatLng(org_bottom_left);\r\n      let northEast = this.map.layerPointToLatLng(org_top_right);\r\n      let latlng_bounds = L.latLngBounds(southWest, northEast);\r\n      try {\r\n        let params = {\r\n          north_east_lat: northEast.lat,\r\n          north_east_lng: northEast.lng,\r\n          south_west_lat: southWest.lat,\r\n          south_west_lng: southWest.lng,\r\n          filters: JSON.stringify(this.search_filters),\r\n          page:this.page\r\n        };\r\n        // if(!refresh && this.refreshing_data){\r\n        //   throw new TypeError();\r\n        // }\r\n        let res = await $.ajax({\r\n          url: \"/api/method/maalek.api.search_properties\",\r\n          type: \"GET\",\r\n          data: params,\r\n        });\r\n        // if(!refresh && this.refreshing_data){\r\n        //   throw new TypeError();\r\n        // }\r\n        total_records_retrieved = res.message[\"results\"].length;\r\n        if(refresh){\r\n          this.page = 0;\r\n          for (property_index in this.property_name_list) {\r\n            this.property_list[property_index][\"dirty\"] = true;\r\n          }\r\n          this.clean_markers();\r\n        }\r\n        if (this.map.getZoom() >= this.big_lvl) {\r\n          this.big_icon = true;\r\n        } else {\r\n          this.big_icon = false;\r\n        }\r\n        this.group_by = res.message[\"group_by\"];\r\n        if(this.group_by == 'property'){\r\n          for (let index = 0; index < total_records_retrieved; index++) {\r\n            var property = res.message[\"results\"][index];\r\n            var property_name = property['name'];\r\n            if (this.property_name_list.includes(property_name)) {\r\n              var p_index = this.property_name_list.indexOf(property_name);\r\n              property[\"dirty\"] = false;\r\n              property[\"marker\"] = this.property_list[p_index][\"marker\"];\r\n              property[\"marker\"].setIcon(this.normal_property_icon(property));\r\n              this.property_list[p_index] = property;\r\n              continue;\r\n            }else{\r\n              this.ad_type_count[property.ad_type]++;\r\n              this.property_type_count[property.property_type]++;\r\n              var propertyIcon = this.normal_property_icon(property);\r\n              tmp_marker = L.marker([property.lat, property.lng], {\r\n                icon: propertyIcon,\r\n                opacity: this.normal_opacity,\r\n                riseOnHover: true,\r\n              })\r\n                .on(\"click\", (e) => {\r\n                  this.markerOnClick(e.target.property);\r\n                })\r\n                .on(\"mouseover\", (e) => {\r\n                  this.hovered_property_type = null;\r\n                  this.hovered_ad_type = null;\r\n                  this.refresh_hovering(false, e.target.property);\r\n                })\r\n                .on(\"mouseout\", (e) => {\r\n                  this.hovered_property_type = null;\r\n                  this.hovered_ad_type = null;\r\n                  this.refresh_hovering(false);\r\n                })\r\n                .addTo(this.map);\r\n              property[\"marker\"] = tmp_marker;\r\n              property[\"dirty\"] = false;\r\n              tmp_marker[\"property\"] = property;\r\n              this.property_list.push(property);\r\n              this.property_name_list.push(property[\"name\"]);\r\n            }\r\n          }\r\n        }else{\r\n          for (let index = 0; index < total_records_retrieved; index++) {\r\n            let cluster = res.message[\"results\"][index];\r\n            var lat_lng;\r\n            var tooltip = L.tooltip({\r\n                permanent: true,\r\n                direction: 'center',\r\n                className: 'region-text'\r\n            }).setContent(cluster.total_properties.toString());\r\n            if(this.group_by == 'region'){\r\n              region_data = global.global_params.get_region(cluster.region_id);\r\n              var geo_json = JSON.parse(region_data.bounds);\r\n              var latlngs = geo_json.features[0].geometry.coordinates[0][0];\r\n              // lat_lng\r\n              var polygon = L.geoJSON(geo_json,{\r\n                  style: function (feature) {\r\n                      return {color: region_data.color};\r\n                  },\r\n                  onEachFeature:function (feature, layer) {\r\n                    layer.bindTooltip(tooltip);\r\n                  }\r\n              });\r\n              cluster[\"marker\"] = polygon\r\n            }else{\r\n              cluster[\"marker\"] = L.circleMarker([cluster.center_lat, cluster.center_lng], {\r\n                radius: this.group_by=='city'?24:40,\r\n                opacity: 0.8,\r\n                fillOpacity: 0.4,\r\n                color: \"#014116\",\r\n                fillColor: \"#ffffff\",\r\n                weight: 2\r\n              }).bindTooltip(tooltip);\r\n            }\r\n            cluster[\"marker\"][\"cluster\"] = cluster;\r\n            cluster[\"marker\"].on(\"click\", (e) => {\r\n                this.map.setView([e.target.cluster.center_lat, e.target.cluster.center_lng], this.group_by=='city'?12:10);\r\n              })\r\n              .on(\"mouseover\", (e) => {\r\n                this.hover_cluster = e.target.cluster;\r\n              })\r\n              .on(\"mouseout\", (e) => {\r\n                this.hover_cluster = null;\r\n              }).addTo(this.map);\r\n\r\n            this.clusters.push(cluster);\r\n          }\r\n        }\r\n        if(refresh){\r\n          let users_res = await $.ajax({\r\n            url: \"/api/method/maalek.api.search_promoted_users\",\r\n            type: \"GET\",\r\n            data: params,\r\n          });\r\n          this.promoted_users = [];\r\n          for (let index = 0; index < users_res.message.length; index++) {\r\n            var promoted_user = users_res.message[index];\r\n            encodeURILogo = encodeURIComponent(promoted_user.logo);\r\n            encodeURILogo = promoted_user.logo;\r\n            promoted_user[\"marker\"] = L.marker([promoted_user.lat, promoted_user.lng], {\r\n                icon: L.divIcon({\r\n                    className: \"promoted-user\", \r\n                    html:\r\n                      '<div class=\"image-holder\" style=\\'background-image: url(\"'+promoted_user.logo+'\");\\'></div>',\r\n                    iconAnchor: [15,30,],\r\n                  }),\r\n                opacity: this.normal_opacity,\r\n                riseOnHover: true,\r\n              }).on(\"click\", (e) => {\r\n                window.open(\"/user-catalogue/\"+promoted_user.name,\"_blank\");\r\n              }).addTo(this.map);\r\n              promoted_user[\"marker\"][\"promoted_user\"] = promoted_user;\r\n            this.promoted_users.push(promoted_user);\r\n          }\r\n          if(this.group_by == 'property'){\r\n            let mashros_data = await $.ajax({\r\n              url: \"/api/method/maalek.api.search_mashros\",\r\n              type: \"GET\",\r\n              data: params,\r\n            });\r\n            for (let index = 0; index < this.mashros.length; index++) {\r\n              this.mashros[index][\"dirty\"] = true;\r\n            }\r\n            for (let index = 0; index < mashros_data.message.length; index++) {\r\n              var mashro = mashros_data.message[index];\r\n              let skip = false;\r\n              for (let p_index = 0; p_index < this.mashros.length; p_index++) {\r\n                if(this.mashros[p_index][\"name\"] == mashro[\"name\"]){\r\n                  this.mashros[p_index][\"dirty\"] = false;\r\n                  // this.mashros[p_index][\"marker\"].setIcon(this.normal_mashro_icon(mashro));\r\n                  mashro[\"logo\"] = this.mashros[p_index][\"logo\"];\r\n                  mashro[\"marker\"] = this.mashros[p_index][\"marker\"];\r\n                  mashro[\"logo\"].setIcon(this.normal_mashro_icon(mashro));\r\n                  this.mashros[p_index] = mashro;\r\n                  if(this.big_icon){\r\n                    mashro[\"marker\"].addTo(this.map);\r\n                  }else{\r\n                    this.map.removeLayer(mashro[\"marker\"]);\r\n                  }\r\n\r\n                  skip = true;\r\n                }\r\n              }\r\n              if(skip)\r\n                continue;\r\n              var geo_json = JSON.parse(mashro[\"location\"]);\r\n              var polygon = L.geoJSON(geo_json,{\r\n                // pointToLayer:function (geoJsonPoint, latlng) {\r\n                //   return L.marker(latlng);\r\n                // }\r\n                // onEachFeature:function (feature, layer) {\r\n                //   layer.bindTooltip(tooltip);\r\n                // }\r\n              }).on(\"click\", (e) => {\r\n                  window.open(\"/project/\"+mashro[\"name\"],\"_blank\");\r\n                });\r\n              mashro[\"marker\"] = polygon\r\n              const proj_icon = this.normal_mashro_icon(mashro);\r\n              mashro[\"logo\"] = L.marker([mashro[\"lat\"], mashro[\"lng\"]], { icon: proj_icon });\r\n              mashro[\"marker\"][\"mashro\"] = mashro;\r\n              mashro[\"logo\"][\"mashro\"] = mashro;\r\n              this.mashros.push(mashro);\r\n              mashro[\"logo\"].on(\"mouseover\", (e) => {\r\n                this.refresh_hovering(false, null, e.target.mashro);\r\n              })\r\n              .on(\"mouseout\", (e) => {\r\n                this.refresh_hovering(false);\r\n              }).addTo(this.map);\r\n              if(this.big_icon){\r\n                mashro[\"marker\"].addTo(this.map);\r\n              }\r\n              // this.map_marker = L.marker([initial_lat, initial_lng]);\r\n              // this.markerLayerGroup.addLayer(this.map_marker);\r\n            }\r\n\r\n            for (let index = 0; index < this.mashros.length; index++) {\r\n              if(this.mashros[index][\"dirty\"]){\r\n                this.map.removeLayer(this.mashros[index][\"marker\"]);\r\n                this.map.removeLayer(this.mashros[index][\"logo\"]);\r\n                this.mashros.splice(index, 1);\r\n              }\r\n              // if(!this.big_icon){\r\n              //   this.map.removeLayer(this.mashros[index][\"marker\"]);\r\n              // }\r\n            }\r\n          }else{\r\n            for (let index = 0; index < this.mashros.length; index++) {\r\n              this.map.removeLayer(this.mashros[index][\"marker\"]);\r\n              this.map.removeLayer(this.mashros[index][\"logo\"]);\r\n            }\r\n            this.mashros.splice(0, this.mashros.length);\r\n          }\r\n        }\r\n        if(refresh){\r\n          global.emitter.emit(\"refresh-property-component\");\r\n          global.emitter.emit(\"refresh_filters\");\r\n        }\r\n        if (this.search_filters.location == undefined){\r\n          this.search_filters.location = search_filters.location;\r\n        }\r\n        this.search_filters.location.zoom = 11;\r\n        this.search_filters.location.center = [\r\n          this.map.getCenter().lat,\r\n          this.map.getCenter().lng\r\n        ];\r\n        this.search_filters.location.zoom = this.map.getZoom();\r\n        localStorage.map_search_filters = JSON.stringify(this.search_filters);\r\n        this.$forceUpdate();\r\n      } catch (e) {\r\n        console.log(e);\r\n        if( !(e instanceof TypeError) ){\r\n          var exceptions = helper.showException(e);\r\n        }\r\n      }\r\n      if(refresh){\r\n        // global.emitter.emit(\"hide-full-loading\");\r\n        this.refreshing_data = false;\r\n      }\r\n      this.is_ready = true;\r\n      if(this.group_by == 'property' && total_records_retrieved != 0){\r\n        this.page++;\r\n        this.load_data(false);\r\n      }else{\r\n        var outbounded_properties = []\r\n        for (var _i in this.property_name_list) {\r\n          if(this.property_list[_i][\"dirty\"]){\r\n            outbounded_properties.push(this.property_name_list[_i]);\r\n          }\r\n        }\r\n        for (var _i in outbounded_properties) {\r\n          var p_index = this.property_name_list.indexOf(outbounded_properties[_i]);\r\n          this.ad_type_count[this.property_list[p_index].ad_type]--;\r\n          this.property_type_count[this.property_list[p_index].property_type]--;\r\n          this.map.removeLayer(this.property_list[p_index][\"marker\"]);\r\n          this.property_list.splice(p_index, 1);\r\n          this.property_name_list.splice(p_index, 1);\r\n        }\r\n        this.still_loading = false;\r\n      }\r\n    },\r\n    markerOnClick: function (property) {\r\n      if(this.selected_property == property){\r\n        this.selected_property = null;\r\n      }else{\r\n        this.selected_property = property;\r\n      }\r\n    },\r\n    propertyOnClick: function (property) {\r\n      this.map.setView([property.marker.lat, property.marker.lng]);\r\n    },\r\n    refresh_hovering: function (clear = false, sl_property=null, sl_mashro=null) {\r\n      this.mouseover_ad_type(clear);\r\n      this.mouseover_property(clear,sl_property);\r\n      this.mouseover_mashro(clear,sl_mashro);\r\n      this.mouseover_property_type(clear);\r\n    },\r\n    big_div_icon: function (property, promote = false) {\r\n      price =\r\n        '<span dir=\"' +\r\n        frappe.lang_dir +\r\n        '\">' +\r\n        helper.nFormatter(property[\"total_price\"]) +\r\n        \"</span>\";\r\n      return L.divIcon({\r\n        className: \"big-property-icon\" + (promote?\" promoted-property-icon\":\"\"),\r\n        // [this.marker_width*this.promote_ratio, this.marker_height*this.promote_ratio]\r\n        html:\r\n          '<img src=\"' +\r\n          global.global_params.map_icons[property.property_type][\r\n            property.ad_type\r\n          ] +\r\n          '\" style=\"width: ' +\r\n          this.marker_width * this.promote_ratio +\r\n          \"px;height: \" +\r\n          this.marker_height * this.promote_ratio +\r\n          'px;\" />' +\r\n          price,\r\n        iconAnchor: [\r\n          (this.marker_width * this.promote_ratio) / 2,\r\n          this.marker_height * this.promote_ratio,\r\n        ],\r\n      });\r\n    },\r\n    normal_property_icon: function (property) {\r\n      if (this.big_icon) {\r\n        return this.big_div_icon(property);\r\n      }\r\n      return L.icon({\r\n        iconUrl: global.global_params.map_icons[\"Default\"][property.ad_type],\r\n        iconSize: [this.default_marker_width, this.default_marker_height],\r\n        iconAnchor: [this.default_marker_width / 2, this.default_marker_height],\r\n        popupAnchor: [\r\n          (this.marker_width * this.promote_ratio) / 2,\r\n          -(this.marker_height * this.promote_ratio) / 2,\r\n        ],\r\n        tooltipAnchor: [\r\n          (this.marker_width * this.promote_ratio) / 2,\r\n          -(this.marker_height * this.promote_ratio) / 2,\r\n        ],\r\n      });\r\n    },\r\n    promote_property_marker: function (p_index,promote = false) {\r\n      var icon = this.big_div_icon(this.property_list[p_index],promote);\r\n      // this.property_list[p_index][\"marker\"].setOpacity(this.promote_opacity);\r\n      this.property_list[p_index][\"marker\"].setIcon(icon);\r\n      this.property_list[p_index][\"marker\"].setZIndexOffset(100);\r\n    },\r\n    dim_property_marker: function (p_index) {\r\n      var icon = this.normal_property_icon(this.property_list[p_index]);\r\n      // this.property_list[p_index][\"marker\"].setOpacity(this.dim_opacity);\r\n      this.property_list[p_index][\"marker\"].setIcon(icon);\r\n      this.property_list[p_index][\"marker\"].setZIndexOffset(0);\r\n    },\r\n    normal_property_marker: function (p_index) {\r\n      var icon = this.normal_property_icon(this.property_list[p_index]);\r\n      // this.property_list[p_index][\"marker\"].setOpacity(this.normal_opacity);\r\n      this.property_list[p_index][\"marker\"].setIcon(icon);\r\n      this.property_list[p_index][\"marker\"].setZIndexOffset(0);\r\n    },\r\n    // size_changed: function () {\r\n    //   for (var _i in this.property_name_list) {\r\n    //     this.normal_property_marker(_i);\r\n    //   }\r\n    //   this.$forceUpdate();\r\n    // },\r\n    mouseover_property_type: function (clear = false) {\r\n      if (clear && this.hovered_property_type) {\r\n        this.hovered_property_type = null;\r\n      }\r\n      if (this.hovered_property_type == this.prv_hovered_property_type) return;\r\n      this.prv_hovered_property_type = this.hovered_property_type;\r\n      for (var _i in this.property_name_list) {\r\n        if (this.hovered_property_type == null) {\r\n          this.normal_property_marker(_i);\r\n        } else if (\r\n          this.property_list[_i].property_type == this.hovered_property_type\r\n        ) {\r\n          this.promote_property_marker(_i,true);\r\n        } else {\r\n          this.dim_property_marker(_i);\r\n        }\r\n      }\r\n      this.$forceUpdate();\r\n    },\r\n    mouseover_ad_type: function (clear = false) {\r\n      if (clear && this.hovered_ad_type) {\r\n        this.hovered_ad_type = null;\r\n      }\r\n      if (this.hovered_ad_type == this.prv_hovered_ad_type) return;\r\n      this.prv_hovered_ad_type = this.hovered_ad_type;\r\n      for (var _i in this.property_name_list) {\r\n        if (this.hovered_ad_type == null) {\r\n          this.normal_property_marker(_i);\r\n        } else if (this.property_list[_i].ad_type == this.hovered_ad_type) {\r\n          this.promote_property_marker(_i,true);\r\n        } else {\r\n          this.dim_property_marker(_i);\r\n        }\r\n      }\r\n      this.$forceUpdate();\r\n    },\r\n    mouseover_property: function (clear = false,sl_property = null) {\r\n      this.hovered_property = sl_property;\r\n      if (clear && this.hovered_property) {\r\n        this.hovered_property = null;\r\n      }\r\n      for (var _i in this.property_name_list) {\r\n        if (this.hovered_property == null) {\r\n          this.normal_property_marker(_i);\r\n        } else if (this.property_list[_i] == this.hovered_property) {\r\n          this.promote_property_marker(_i,true);\r\n        } else {\r\n          this.dim_property_marker(_i);\r\n        }\r\n      }\r\n      this.$forceUpdate();\r\n    },\r\n    region_changed: function () {\r\n      if (\r\n        this.prv_region == this.search_filters.region ||\r\n        this.search_filters.region == \"\" ||\r\n        this.search_filters.region == null\r\n      ) {\r\n        return false;\r\n      }\r\n      this.prv_region = this.search_filters.region;\r\n      this.search_filters.city = null;\r\n      this.search_filters.district = null;\r\n      var region =\r\n        global.global_params.regions[\r\n          global.global_params.region_indexes[\r\n            this.search_filters.region.region_id\r\n          ]\r\n        ];\r\n      var latlng = L.latLng(region.center[1], region.center[0]);\r\n      this.map.setView([latlng.lat, latlng.lng], 12);\r\n      return true;\r\n    },\r\n    city_changed: function () {\r\n      if (\r\n        this.prv_city == this.search_filters.city ||\r\n        this.search_filters.city == \"\" ||\r\n        this.search_filters.city == null\r\n      ) {\r\n        return false;\r\n      }\r\n      this.prv_city = this.search_filters.city;\r\n      this.search_filters.district = null;\r\n      // var city = global.global_params.cities[global.global_params.city_indexes[this.search_filters.city.cty_id]];\r\n      var latlng = L.latLng(\r\n        this.search_filters.city.center[1],\r\n        this.search_filters.city.center[0]\r\n      );\r\n      this.map.setView([latlng.lat, latlng.lng], 12);\r\n      return true;\r\n    },\r\n    district_changed: function () {\r\n      if (\r\n        this.prv_district == this.search_filters.district ||\r\n        this.search_filters.district == \"\" ||\r\n        this.search_filters.district == null\r\n      ) {\r\n        return false;\r\n      }\r\n      this.prv_district = this.search_filters.district;\r\n      var district =\r\n        global.global_params.districts[\r\n          global.global_params.district_indexes[this.search_filters.district]\r\n        ];\r\n      var latlng = L.latLng(district.center[1], district.center[0]);\r\n      this.map.setView([latlng.lat, latlng.lng], 12);\r\n      return true;\r\n    },\r\n    refresh_page: function () {\r\n      window.location.replace(\"/search\");\r\n    },\r\n    big_mashro_div_icon: function (mashro, promote = false) {\r\n      mashro_title = helper.truncateSafeText(mashro[\"title\"],10);\r\n      const textIcon = L.divIcon({\r\n          className: 'custom-text-marker', // optional (can be empty)\r\n          html: '<a href=\"/project/'+mashro[\"name\"]+'\" target=\"_BLANK\" class=\"marker-label\">'+mashro_title+' <i class=\"fa-solid fa-square-arrow-up-right\"></i></a>',\r\n          iconSize: [100, 30], // adjust based on content\r\n          iconAnchor: [50, 15] // center it\r\n      });\r\n      return textIcon;\r\n    },\r\n    normal_mashro_icon: function (mashro) {\r\n      if (this.big_icon) {\r\n        return this.big_mashro_div_icon(mashro);\r\n      }\r\n      return L.icon({\r\n        iconUrl: global.global_params.map_icons[\"Mashro\"],\r\n        iconSize: [this.default_marker_width, this.default_marker_height],\r\n        iconAnchor: [(this.default_marker_width)/2, this.default_marker_height],\r\n        popupAnchor: [\r\n          (this.marker_width * this.promote_ratio) / 2,\r\n          -(this.marker_height * this.promote_ratio) / 2,\r\n        ],\r\n        tooltipAnchor: [\r\n          (this.marker_width * this.promote_ratio) / 2,\r\n          -(this.marker_height * this.promote_ratio) / 2,\r\n        ],\r\n      });\r\n    },\r\n    promote_mashro_marker: function (p_index,promote = false) {\r\n      var icon = this.big_mashro_div_icon(this.mashros[p_index],promote);\r\n      this.mashros[p_index][\"logo\"].setIcon(icon);\r\n      this.mashros[p_index][\"logo\"].setZIndexOffset(100);\r\n    },\r\n    normal_mashro_marker: function (p_index) {\r\n      var icon = this.normal_mashro_icon(this.mashros[p_index]);\r\n      this.mashros[p_index][\"logo\"].setIcon(icon);\r\n      this.mashros[p_index][\"logo\"].setZIndexOffset(0);\r\n    },\r\n    mouseover_mashro: function (clear = false,sl_mashro = null) {\r\n      this.hovered_mashro = sl_mashro;\r\n      if (clear && this.hovered_mashro) {\r\n        this.hovered_mashro = null;\r\n      }\r\n      for (var _i in this.mashros) {\r\n        if (this.hovered_mashro == null) {\r\n          this.normal_mashro_marker(_i);\r\n        } else if (this.mashros[_i] == this.hovered_mashro) {\r\n          this.promote_mashro_marker(_i,true);\r\n        }\r\n      }\r\n      this.$forceUpdate();\r\n    },\r\n    \r\n  },\r\n  computed: {},\r\n};\r\n</script>\r\n\r\n<style>\r\nhr {\r\n  margin: 0 !important;\r\n}\r\ntable td {\r\n  padding: 0 5px;\r\n}\r\n.legend {\r\n  padding: 6px 4px;\r\n  font-size: 14px;\r\n  background: rgba(255, 255, 255, 0.4);\r\n  line-height: 24px;\r\n  color: #555;\r\n  z-index: 2000;\r\n  bottom: 0;\r\n  position: absolute;\r\n}\r\n.legend tr {\r\n  cursor: pointer;\r\n}\r\n.legend:hover {\r\n  background: white;\r\n}\r\n.legend h4 {\r\n  text-align: center;\r\n  font-size: 16px;\r\n  margin: 2px 12px 8px;\r\n  color: #777;\r\n}\r\n\r\n.legend img {\r\n  width: 20px;\r\n  height: 24px;\r\n}\r\n\r\n.legend i {\r\n  width: 18px;\r\n  height: 18px;\r\n  float: left;\r\n  margin: 0 8px 0 0;\r\n  opacity: 0.7;\r\n}\r\n\r\n.legend i.icon {\r\n  background-size: 18px;\r\n  background-color: rgba(255, 255, 255, 1);\r\n}\r\n\r\n.single-agents-details .deborah-wrap {\r\n  padding: 10px;\r\n}\r\n\r\n.big-property-icon {\r\n  width: max-content !important;\r\n  height: max-content !important;\r\n  direction: ltr;\r\n}\r\n.big-property-icon img {\r\n  margin-right: 2px;\r\n}\r\n.big-property-icon span,\r\n.big-property-icon p {\r\n  font-size: 1.2em;\r\n  background-color: white;\r\n  padding: 0 5px;\r\n  border: 1px solid transparent;\r\n  border-color: black;\r\n  border-radius: 10px 10px 10px 0px;\r\n}\r\n\r\n#list-properties {\r\n  overflow-x: hidden;\r\n  overflow-y: scroll;\r\n  width: 100%;\r\n  padding-bottom: 10em;\r\n  -ms-overflow-style: none; /* Internet Explorer 10+ */\r\n  scrollbar-width: none; /* Firefox */\r\n}\r\n#list-properties::-webkit-scrollbar {\r\n  display: none; /* Safari and Chrome */\r\n}\r\n.map-button{\r\n  border: 2px solid rgba(0, 0, 0, 0.2);\r\n  border-radius: 4px;\r\n}\r\n.leaflet-tooltip-pane{\r\n  direction: ltr;\r\n}\r\n.leaflet-tooltip-pane .text {\r\n  color: #014116; \r\n  font-weight: bold;\r\n  background: transparent;\r\n  border:0;\r\n  box-shadow: none;\r\n  font-size:1.6em;\r\n}\r\n.leaflet-tooltip-pane .region-text {\r\n  color: #014116; \r\n  font-weight: bold;\r\n  background: transparent;\r\n  border:0;\r\n  box-shadow: none;\r\n  font-size:3em;\r\n}\r\n\r\n.promoted-user{\r\n  background-color: white;\r\n  width: 30px !important;\r\n  height: 30px !important;\r\n}\r\n\r\n.promoted-user .image-holder{\r\n  display: block;\r\n  padding-top: 100%;\r\n  width: 30px;\r\n  height: 30px;\r\n  background-repeat: no-repeat;\r\n  background-size: contain;\r\n  background-position: center;\r\n}\r\n\r\n.promoted-property-icon span{\r\n  background-color: #014116;\r\n  color: #fff;\r\n}\r\n\r\n.marker-label{\r\n  padding: 0px 10px;\r\n  background-color: black;\r\n  text-align: center;\r\n  color: white !important;\r\n  border-radius: 5px;\r\n}\r\n\r\n.marker-label:hover{\r\n  background-color: #014116;\r\n  color: white !important;\r\n}\r\n\r\n.marker-label:hover *{\r\n  color: white !important;\r\n}\r\n</style>\r\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/widgets/map-search-widget.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__